module.exports = __webpack_public_path__ + "img/news35-0.44b8fc26.png";